// React-
import React, { useContext, Suspense, useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

// Routes-
import SplashScreen from '../components/shared/splash-screen/SplashScreenComponent';
import AdminRoute from './content/admin/routes';
import ConfigurationRoute from './content/configurations/routes';
import ControlsRoute from './content/controls/routes';
import DashboardRoute from './content/dashboard/routes';
import MaterialTrackingRoute from './content/material-tracking/routes';
import LiveLineDashboardRoute from './content/liveline-dashboard/routes';
import MachineLearningRoute from './content/machine-learning/routes';
import ModelMetricsRoute from './content/model-metrics/routes';
import AlertLogRoute from './content/alert-log/routes';
import MonitorStackRoute from './content/monitor-stack/routes';
import MonitorRoute from './content/monitor/routes';
import OEEConsoleRoutes from './content/oee-console/routes';
import OperatorRoute from './content/operator/routes';
import PredictiveAlarmsRoute from './content/predictive-alarms/routes';
import ReportingRoute from './content/reporting/routes';
import ServerSummaryRoute from './content/server-summary/routes';
import UserProfileRoute from './content/user-profile/routes';
import PrivateRoutes from './private-routes';
import SSOCallbackHandler from './private-routes/auth-components/SSOCallbackHandler';

import { User } from '../state/features/authReducer';

const ContentRoutes = () => {
    const dashboardRoute = DashboardRoute();
    const materialTrackingRoute = MaterialTrackingRoute();
    const livelineDashboardRoute = LiveLineDashboardRoute();
    const oeeConsoleRoutes = OEEConsoleRoutes();
    const modelMetrics = ModelMetricsRoute();
    const alertLog = AlertLogRoute();
    const operatorRoute = OperatorRoute();
    const adminRoute = AdminRoute();
    const monitorRoute = MonitorRoute();
    const configurationRoute = ConfigurationRoute();
    const serverSummaryRoute = ServerSummaryRoute();
    const controlsRoute = ControlsRoute();
    const monitorStackRoute = MonitorStackRoute();
    const reportingRoute = ReportingRoute();
    const predictiveAlarmsRoute = PredictiveAlarmsRoute();
    const machineLearningRoute = MachineLearningRoute();
    const userProfileRoute = UserProfileRoute();

    const routeObj = [
        ...dashboardRoute,
        ...materialTrackingRoute,
        ...livelineDashboardRoute,
        ...operatorRoute,
        ...adminRoute,
        ...monitorRoute,
        ...configurationRoute,
        ...serverSummaryRoute,
        ...controlsRoute,
        ...monitorStackRoute,
        ...reportingRoute,
        ...predictiveAlarmsRoute,
        ...machineLearningRoute,
        ...oeeConsoleRoutes,
        ...modelMetrics,
        ...alertLog,
        ...userProfileRoute,
    ];

    const stored = localStorage.getItem('user') || '{}';
    const user = JSON.parse(stored);

    // Created to use in the LandingComponent dependency array to avoid unnecessary re-renders of the component-
    const permissionsString = JSON.stringify(user?.permissions ?? []);

    // Landing location for the user role of cell_operator-
    const LandingComponent = useMemo(() => {
        const permissionsArray = JSON.parse(permissionsString);
        const is_cell_operator = permissionsArray.some(
            (permission) => permission?.role === 'cell_operator',
        );
        return is_cell_operator
            ? '/live_historical_data/advanced_controllers'
            : '/dashboard';
    }, [permissionsString]);

    return (
        <Routes>
            <Route path="/auth/callback" element={<SSOCallbackHandler />} />
            <Route path="/" element={<PrivateRoutes />}>
                {/* Default route */}
                <Route
                    index
                    element={
                        <Navigate to={LandingComponent} replace />
                    }
                />

                {routeObj &&
                    routeObj.map((route) => {
                        return (
                            <Route
                                key={route?.key}
                                path={route?.path}
                                element={
                                    <Suspense
                                        fallback={<SplashScreen />}
                                    >
                                        {route?.component}
                                    </Suspense>
                                }
                            />
                        );
                    })}
            </Route>
            <Route
                key={'any'}
                path="*"
                element={<Navigate to={'/dashboard'} />}
            />
        </Routes>
    );
};

export default ContentRoutes;
